import React from 'react';
import { Scene, SceneProps } from './common';
import { CalendarScene } from './CalendarScene';
import { SelectStationScene } from './SelectStationScene';
import { SummaryScene } from './SummaryScene';

const scenes: Scene[] = [
  {
    node: (props: SceneProps) => (
      <SelectStationScene {...props} direction="departure" />
    ),
  },
  {
    node: (props: SceneProps) => <SummaryScene onlyLocations {...props} />,
  },
  {
    node: (props: SceneProps) => <CalendarScene {...props} />,
  },
  {
    node: (props: SceneProps) => <SummaryScene {...props} />,
  },
];

type Props = {
  onClose: () => void;
  onConfirm: () => void;
};

const SearchWizard = ({ onClose, onConfirm }: Props) => {
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const currentScene = scenes[currentIndex];
  return currentScene.node({
    onClose: () => {
      if (currentScene.goBackOnClose && currentIndex > 0) {
        setCurrentIndex(currentIndex - 1);
      } else {
        onClose();
      }
    },
    onConfirm: () => {
      if (currentIndex === scenes.length - 1) {
        onConfirm();
      } else {
        setCurrentIndex(currentIndex + 1);
      }
    },
  });
};

export { SearchWizard };
